import { createSlice } from '@reduxjs/toolkit';
import * as Seters from './seters';

export interface State {
	isBodyScrolled: boolean;
	viewportWidth: number;
	loaded: boolean;
	paymentStatus: 'pending' | 'finished';
	lastPaymentIntervalId: NodeJS.Timer | null;
}

export const initialState: State = {
	isBodyScrolled: false,
	viewportWidth: window.innerWidth,
	loaded: false,
	paymentStatus: 'pending',
	lastPaymentIntervalId: null,
};

export const slice = createSlice({
	name: 'ui/app',
	initialState,
	reducers: Seters,
});

export const appReducer = slice.reducer;
const Actions = slice.actions;
export { Actions };
